import React from 'react';

const AffiliateProgram: React.FC = () => {
  return (
    <div>
      <h1>Affiliate Program</h1>
      <p>This is the affiliate program page for PortfoliosLab. It will contain information about our affiliate program and how to participate.</p>
    </div>
  );
};

export default AffiliateProgram;
